export default __webpack_public_path__ + "static/media/PlasticMoldingImg2.6a9807e5.jpg";